module.exports = __webpack_public_path__ + "img/绿色设计流程图.fc59fcd3.png";